import _slicedToArray from "/home/ncv/Documents/projects/ve/apps/ve-front/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { createContext } from "@chakra-ui/react-utils";

var _createContext = createContext({
  name: "PopoverContext",
  errorMessage: "usePopoverContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Popover />`"
}),
    _createContext2 = _slicedToArray(_createContext, 2),
    PopoverProvider = _createContext2[0],
    usePopoverContext = _createContext2[1];

export { PopoverProvider, usePopoverContext };